import { Component, inject, OnInit } from "@angular/core";
import { LayoutService } from "@core/services/layout.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-mention-legal',
  templateUrl: './mention-legal.page.html',
  styleUrls: ['./mention-legal.page.scss']
})
export class MentionLegalPage implements OnInit {
  private readonly layoutService = inject(LayoutService);
  private readonly languageService = inject(TranslateService);

  ngOnInit(): void {
    this._setupLayout();
  }

  private _setupLayout(): void {
    this.layoutService.updateHeaderConfig({ ...this.layoutService.headerConfig$(), useHeader: true, useLogoutButton: false, useBackButton: false });
  }

  get currentLange(): string {
    return this.languageService.currentLang;
  }
}
